module.exports = __webpack_public_path__ + "media/app/containers/CheckoutPage/icons/emptyCart.ca0c7963.svg";